import script from "./LaputaRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./LaputaRegister.vue?vue&type=script&setup=true&lang=js"

import "./LaputaRegister.vue?vue&type=style&index=0&id=62ecb066&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62ecb066"]])

export default __exports__